import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import EnvironmentService from '@/env/EnvironmentService';


export default /*#__PURE__*/_defineComponent({
  __name: 'HighLtvAlert',
  props: {
    value: { type: Boolean }
  },
  setup(__props: any) {



const store = useSimulationStore();

const isMaximumAvailableLTV = computed<boolean>(() => {
  const percentage = EnvironmentService.Environment.getAppDomainConfig().maximumLTVPercentage;
  const loanAmount: number = store.userInput?.loanAmount || 0;
  const hypothecValue: number = store.userInput?.hypothecValue || 0;
  return Boolean(loanAmount && loanAmount > ((hypothecValue * percentage) / 100));
});


return { __sfc: true,store, isMaximumAvailableLTV }
}

})